// @ts-nocheck

import * as R from 'ramda';
import { LOADING_STATUS } from '../../support/constants';
import { reducerWrapper } from '../../support/utils';

import { AASA_URL } from '../../actions/EmailOnboarding/ClickTracking';

var INIT_STATE = {
  loading: false,
  loadingStatus: LOADING_STATUS.INIT,
  error: null,
  data: null,
};

function Handler(state, action) {
  switch (action.type) {
    case AASA_URL.response:
      return R.merge(state, {
        loading: false,
        loadingStatus: LOADING_STATUS.LOADED,
        error: null,
        data: action.data,
      });
    default:
      return state;
  }
}

const AASAUrl = reducerWrapper(INIT_STATE, Handler, {
  request: [AASA_URL],
  error: [AASA_URL],
  resetOn: ['APP_CHANGE'],
});

export default AASAUrl;
